import axios from "axios";
import config from "../../settings";

export const ibanCheckAPI = {



    //getNominationsBySearchFilter: (searchFilter, thenCallback) => {
    getIbanCheck: (searchFilter, authorizationCode, thenCallback) => {
        //console.log(`${config.baseUrl}`);
       // console.log(`${config.checkIBAN}`);

        //axios.post(`${config.baseUrl}${config.checkIBAN}${config.checkIBANCode}`, searchFilter,  {
            axios.post(`${config.baseUrl}${config.checkIBAN}${config.checkIBANCode}&authorizationCode${authorizationCode}`, searchFilter,  {
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'}
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);

                window.sessionStorage.removeItem('user');
                window.location.href = "/unauthorized";
            })
    },

    getIbanArrayCheck: (searchFilter, authorizationCode, thenCallback) => {


        axios.post(`${config.baseUrl}${config.checkIBANarray}${config.checkIBANarrayCode}&authorizationCode${authorizationCode}`, searchFilter,  {
            headers: { 'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'}
        })
            .then(res => {
                thenCallback(res.data);
            })
            .catch(err => {
                console.log(err);

                window.sessionStorage.removeItem('user');
                window.sessionStorage.removeItem('code');
                window.location.href = "/unauthorized";
            })
    }


}